import React from 'react';
import Sidebar from './../../components/sidebar';
import {withRouter} from 'react-router-dom';

class MapSidebar extends Sidebar.Sidebar {
    //TODO: maybe we can remove this and all per-screen sidbars?
}

export default withRouter((props) => {
    return <MapSidebar {...props}/>
})


// WEBPACK FOOTER //
// ./src/screens/map/sidebar.js